
import { useState } from "react";
import styled from "styled-components";
import { itemHistory, naira } from "../../../utils/data";
import { Input } from "../../../styles";
import { useDashboardContext } from "../../../context/dashboard_context";


const BestSellingCategory = () => {


      const [load, setload] = useState(false);
      // const [itemHistory, setitemHistory] = useState([]);
      const [key, setkey] = useState('');

      const { dashboardData } = useDashboardContext();

      const { topSell } = dashboardData;


      return (
            <StyledBestSellingCategory className="h-100">
                  <div className="main-container">
                        <div className="justify-content-between row">
                              <h4 className="grey-bold-text">
                                    Best Selling Category
                              </h4>
                              {/* <div className="py-2 col-lg-4">
                                    <Input
                                          type="month"
                                          className='m-0 rounded-0 month-input'
                                          onChange={(e) => setkey(e.target.value)} />
                              </div> */}
                        </div>


                        <div className="light-bg br-md">

                              <div className="table-responsive">
                                    <table className='table p-2 border-0 text-center text-nowrap br-md fs-6' >
                                          <thead>
                                                <tr className=''>
                                                      <th scope="col" className='text-start grey-text'>
                                                            Category
                                                      </th>
                                                      <th scope="col" className='grey-text'>
                                                            Turn Over
                                                      </th>
                                                      <th scope="col" className='grey-text'>
                                                            Increase By
                                                      </th>

                                                </tr>
                                          </thead>

                                          <tbody>
                                                {/* {itemHistory?.filter((x) => x.name.toLowerCase().includes(key.toLowerCase())).map(({ name, price, remQuantity, soldQuantity }, i) => { */}
                                                {itemHistory.map(({ name, price, soldQuantity }, i) => {
                                                      return (
                                                            <tr className='py-2' key={i}>
                                                                  <td className="text-start">{name}</td>
                                                                  <td className="">{naira}{price}</td>
                                                                  <td className=" ">{soldQuantity}</td>
                                                            </tr>
                                                      );
                                                })
                                                }
                                          </tbody>

                                    </table>
                              </div>
                        </div>
                  </div>


            </StyledBestSellingCategory>
      );
};

export default BestSellingCategory;

const StyledBestSellingCategory = styled.div`
      

      input.month-input {
            border-radius: 0px !important;
            padding: 4px 4px;
            border-color: #a8a5a5;
      }


`;